export default __webpack_public_path__ + "static/media/4typesCard2.aeba6b8e.png";